module.exports = __webpack_public_path__ + "static/media/MHRM09N1400.3da42248.svg";